import styled, { css } from 'styled-components';

export const SocialsContainer = styled.div`
    
`;

export const SocialButton = styled.button`
    border: 2px solid ${props => props.theme.body.text};
    outline: none;
    border-radius: 50%;
    cursor: pointer;
    background: transparent;
    -webkit-transition: ${props => props.theme.transition};
    -o-transition: ${props => props.theme.transition};
    transition: ${props => props.theme.transition};
    color: ${props => props.theme.body.text};
    font-size: 20px;
    height: 3rem;
    width: 3rem;
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;

    &:hover {
        background: ${props => props.theme.body.text};
        color: ${props => props.theme.body.background};
        -webkit-transform: translateY(-2px) scale(1.05);
            -ms-transform: translateY(-2px) scale(1.05);
                transform: translateY(-2px) scale(1.05);
        -webkit-box-shadow: 0px 4px 12px rgba(0, 0, 0, 0.15);
                box-shadow: 0px 4px 12px rgba(0, 0, 0, 0.15);
    }

    &:focus {
        -webkit-transform: scale(0.98);
            -ms-transform: scale(0.98);
                transform: scale(0.98);
    }

    i {
        position: absolute;
        top: 50%;
        left: 50%;
        -webkit-transform: translate(-50%, -50%);
            -ms-transform: translate(-50%, -50%);
                transform: translate(-50%, -50%);
        color: inherit;
        line-height: 1;

        @media only screen and (max-width: ${props => props.theme.queries.mobile}) {
            position: absolute;
            top: 50%;
            left: 50%;
            -webkit-transform: translate(-50%, -50%);
                -ms-transform: translate(-50%, -50%);
                    transform: translate(-50%, -50%);
        }
    }

    ${props => props.social === 'linkedin' &&
        css`
            background: #0077B5;
            color: white;

            &:hover {
                background: darken(#0077B5, 10%);
                color: white;
            }
        `
    }

    ${props => props.social === 'dribbble' &&
        css`
            background: #ea4c89;

            &:hover {
                background: darken(#ea4c89, 10%);
                color: white;
                border-color: #ea4c89;
            }
        `
    }

    ${props => props.social === 'codepen' &&
        css`
            background: #FFF;
            color: black;
            
            &:hover {
                background: #EEE;
                color: black;
            }
        `
    }

    ${props => props.margin &&
        css`
            margin-left: ${props.margin}rem; 
            margin-right: ${props.margin}rem; 
        `
    }
`;
